// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__Yz0k_","file":"styles_file__9c0wX"};